import { Trans } from 'react-i18next'

import { USER_ITEM_SUPPORT_EMAIL } from '../../../../constants/user'
import { useUk } from '../../../../hooks'
import { getQaSelector } from '../../../../utils/common'
import { getHtmlEmailLink } from '../../../../utils/link'
import { Link } from '../../../Link'
import { AuthHelpText } from '../../AuthHelpText'

import { QA_NAME_AUTH_ABOUT_MANUFACTURER_EMAIL_LINK } from './AuthAboutManufacturer.constants'

import * as styles from './AuthAboutManufacturer.module.css'

function AuthAboutManufacturer() {
  const { name: ukName } = useUk()

  return (
    <AuthHelpText
      text={
        <Trans
          components={{
            emailLink: (
              <Link
                {...getQaSelector({
                  value: QA_NAME_AUTH_ABOUT_MANUFACTURER_EMAIL_LINK,
                })}
                className={styles.emailLink}
                to={getHtmlEmailLink(USER_ITEM_SUPPORT_EMAIL)}
              />
            ),
            strong: <strong />,
          }}
          i18nKey='Auth.AboutManufacturerTextKey'
          values={{ email: USER_ITEM_SUPPORT_EMAIL, ukName }}
        />
      }
    />
  )
}

export default AuthAboutManufacturer
